import $ from 'jquery'
import owlCarousel from "owl.carousel";

function counter() {
    setTimeout(function() {
        let active_slide  = $('.owl-item.active').find('.project__slide-image');
        let active_number = active_slide.attr('data-slide');

        $('.slide-counter').text(active_number);
    }, 50 );
}

export function setup_sliders() {

    $(".slider").each(function() {
        if (!$(this).hasClass("owl-carousel")) {
          $(this).addClass("owl-carousel");
          $(this).owlCarousel({
            nav: true,
            dots: false,
            loop: true,
            items: 1,
            margin: 156,
            navSpeed: 800,
            onChanged: counter,
            responsive: {
                0: {
                    margin: 30,
                    nav: false,
                  },
                  700: {
                    margin: 30,
                    nav: true,
                  },
              },
          });
        }
      });

}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/sliders.js